export default "__VITE_ASSET__DDX$8M8A__"